module.exports = __webpack_public_path__ + "media/images/flags/64/Kiribati-12ee18428e4f786b3492e003dc04389d.png";